import { call, put } from 'redux-saga/effects';

import { apiGeneral, queryBuilder, notify } from 'services';
import { IPaginateRequest } from 'interfaces/paginate-duck';
import { requestErrorHandler } from 'utils';
import { PaginateUserRolesActions } from 'store/ducks/roles';

export function* paginateUserRolesRequest(action: any) {
  try {
    const { query = {} } = action as IPaginateRequest;
    const queryString = queryBuilder(query);

    const { data: responseBody } = yield call(
      apiGeneral.get,
      `/roles?${queryString}`
    );

    const { roles, pagination } = responseBody;
    yield put(PaginateUserRolesActions.success(roles, pagination));
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(PaginateUserRolesActions.failure(errorMessage));
  }
}
